// ЕДИНЫЙ СПРАВОЧНИК ПРИОРИТЕТА ЗАДАЧИ.
//
// ЗАЧЕМ. Подписи и цвета приоритета были объявлены заново в шести местах
// (доска задач, карточка, панель создания, кабинет, боковая панель команды,
// виджет заявок отдела) — у каждого свой словарь. Добавить значение значило
// найти все шесть и не забыть ни одного; на деле они уже разошлись: где-то
// «Обычный» был фиолетовым, где-то оранжевым. Правило портала: похожие
// элементы меняются из ОДНОГО места (docs — «единые элементы интерфейса»).
//
// НАБОР — КАК В ОБРАЗЦЕ (Максим, 01.09.2026: «сделать такие же, как у них
// статусы»). Отличий от прежнего набора три:
//   • приоритета может НЕ БЫТЬ вовсе («Статус приоритета не всегда стоит») —
//     это пустая строка, и она же значение по умолчанию у новой задачи;
//   • «Обычный» называется «средний» — как у них;
//   • добавлен «замороженный»: задача отложена, но не удалена и не закрыта.
// Подписи строчными — тоже как у них: приоритет это метка, а не заголовок.

export type TaskPriority = "" | "high" | "normal" | "low" | "frozen";

export type PriorityMeta = {
  value: TaskPriority;
  label: string;
  /** Цвет метки. Пустой приоритет — приглушённый: он не должен спорить с теми,
   *  что расставлены осознанно. */
  color: string;
};

/** Порядок — как в их списке: сверху «без приоритета», дальше по убыванию. */
export const PRIORITIES: PriorityMeta[] = [
  { value: "", label: "без приоритета", color: "var(--textMuted)" },
  { value: "high", label: "высокий", color: "#ef4444" },
  { value: "normal", label: "средний", color: "#f59e0b" },
  { value: "low", label: "низкий", color: "#22c55e" },
  { value: "frozen", label: "замороженный", color: "#38bdf8" },
];

const ПО_КЛЮЧУ = new Map(PRIORITIES.map((p) => [p.value, p]));

/** Метаданные приоритета. Неизвестное значение из старых данных читается как
 *  «без приоритета», а не роняет экран. */
export function prio(value: string | null | undefined): PriorityMeta {
  return ПО_КЛЮЧУ.get((value ?? "") as TaskPriority) ?? PRIORITIES[0];
}

export const prioLabel = (v: string | null | undefined) => prio(v).label;
export const prioColor = (v: string | null | undefined) => prio(v).color;

/** Заливка метки — тот же цвет, приглушённый до подложки (как чипы в образце). */
export const prioFill = (v: string | null | undefined) =>
  `color-mix(in srgb, ${prio(v).color} 16%, transparent)`;

/** Варианты для `Select`: значение + подпись + точка цвета рисует потребитель. */
export const PRIORITY_OPTIONS = PRIORITIES.map((p) => ({ value: p.value, label: p.label }));
